import { ExperimentActions } from 'client/actions/actionTypes'
import { actionCreatorAsync, AsyncAction } from 'client/actions/index'
import * as api from 'client/api/experiments'
import { ExperimentInterface } from 'client/Interfaces/ExperimentsInterface'

export function getExperiments(): AsyncAction<ExperimentInterface[]> {
  return actionCreatorAsync<ExperimentInterface[]>(ExperimentActions.LOAD_EXPERIMENTS, async () => {
    return Promise.resolve(await api.getExperiments())
  })
}
